// extracted by mini-css-extract-plugin
export var card = "_8v-1";
export var container = "_8v-0";